import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import theme from './assets/connect/theme';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from '@context/snackbar/snackbar-context';
import { UserStatusProvider } from '@context/user-status/UserStatusContext';
import type { OnUpdateCallbackType } from './types/service-worker';

const onUpdateCallback: OnUpdateCallbackType = {};

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider>
          <UserStatusProvider>
            <App onUpdateCallback={onUpdateCallback} />
          </UserStatusProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
